export const ACCOUNT_BUSINESS_UNIT_ID = 0;
export const ALL_BUSINESS_UNITS_VALUE = 'ALL';